<div class="clock">
    <div class="clock__container">
        <span class="clock__date">{{ time().dateFormatted }}</span>
        <span class="clock__time">{{ time().timeFormatted }} <span class="clock__timezone">UTC</span></span>
    </div>
</div>